import React from "react";

export const LockdownScreen = () => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-between bg-gradient-to-br from-blue-600 to-red-600 p-8">
      {/* Main Content - Centered */}
      <div className="flex-1 flex flex-col items-center justify-center gap-6">
        {/* Clash Logo */}
        <img
          src="/CLASH Logo.png"
          alt="CLASH"
          className="w-64 md:w-80 h-auto object-contain"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />

        {/* Game Logo and Name */}
        <div className="flex flex-col items-center gap-4">
          <img
            src="/Connections Logo.png"
            alt="Connections"
            className="w-48 md:w-64 h-auto object-contain"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
          <div className="flex items-center gap-3">
            <img
              src="/Connections Icon.png"
              alt=""
              className="w-12 h-12 object-contain"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
            <h1 className="text-4xl md:text-5xl font-black text-white tracking-tight text-center">
              Connections
            </h1>
          </div>
        </div>
      </div>

      {/* Credits - Bottom */}
      <div className="text-center text-white/80 text-sm">
        <p>© Roslyn High School OCC</p>
        <p className="mt-1">Created by Jordan Feldstein</p>
      </div>
    </div>
  );
};

export default LockdownScreen;
